<template>
  <v-container
    fluid
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="10"
      >
        <reseller-form
          :reseller="reseller"
          :bad-request-reasons="badRequestReasons"
          @saveReseller="saveResellerHandler"
          @closeResellerForm="closeResellerFormHandler"
          @saveAndCloseResellerForm="saveAndCloseResellerFormHandler"
        />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col
        cols="12"
        md="10"
      >
        <customer-list
          :customers="customers"
          :hide-overview="true"
          :hide-new="true"
          :hide-edit="true"
          @new="CustomerNewHandler"
          @refresh="CustomerRefreshHandler"
          @overview="CustomerOverviewHandler"
          @edit="CustomerEditHandler"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import CustomerList from '@/views/components/custom/lists/CustomerList.vue'
  import CustomerService from '@/services/Admin/customerService'
  import ResellerForm from '@/views/components/custom/forms/ResellerForm.vue'

  export default {
    components: {
      ResellerForm,
      CustomerList,
    },
    props: {
      resellerUid: {
        type: String,
        required: false,
        default: null,
      },
    },
    data: () => ({
      reseller: {
        uid: '',
        name: '',
        vatNumber: '',
        houseNumber: '',
        address: '',
        postalCode: '',
        city: '',
        countryCode: '',
        type: 'Reseller',
        vendorIds: [],
        emailAddress: '',
        contactName: '',
        contactPhone: '',
      },
      customers: [],
      badRequestReasons: {},
    }),
    computed: {
      resellers () {
        return this.$store.state.resellers.list
      },
    },
    created: async function () {
      // check depended store items are ready
      if (this.resellers.length < 1) {
        await this.$store.dispatch('RefreshResellers')
      }

      if (!this.resellerUid) {
        return
      }
      // refresh the reseller to make sure we have the newest and full model
      await this.$store.dispatch('RefreshReseller', this.resellerUid)

      var reseller = this.resellers.find(
        el => el.uid === this.resellerUid
      )

      if (!reseller) {
        await this.$store.dispatch('RefreshResellers')
        reseller = this.resellers.find(
          el => el.uid === this.resellerUid
        )
        if (!reseller) {
          console.log('Unable to find reseller by UID')
          return
        }
      }
      this.updateLocalReseller(reseller)

      if (this.customers.length === 0) {
        await this.RefreshCustomers()
      }
    },
    methods: {
      async saveResellerHandler (reseller) {
        var storeChange
        debugger
        var dispatchEvent = !this.reseller.uid ? 'CreateReseller' : 'UpdateReseller'
        var eventLoadingMsg = !this.reseller.uid
          ? this.$t('Components.Forms.Reseller.Messages.ResellerCreateSubmitLoadMessage')
          : this.$t('Components.Forms.Reseller.Messages.ResellerUpdateSubmitLoadMessage')

        storeChange = await this.$store.dispatch(dispatchEvent, reseller, eventLoadingMsg)

        if (storeChange.success === true) {
          this.updateLocalReseller(storeChange.value)
          return true
        } else {
          this.badRequestReasons = storeChange.badRequestReasons.errors
        }

        return false
      },
      async saveAndCloseResellerFormHandler (reseller) {
        if (await this.saveResellerHandler(reseller)) {
          this.closeResellerFormHandler()
        }
      },
      closeResellerFormHandler () {
        this.$router.go(-1)
      },
      updateLocalReseller (data) {
        this.reseller.uid = data.uid
        this.reseller.name = data.name
        this.reseller.vatNumber = data.vatNumber
        this.reseller.houseNumber = data.houseNumber
        this.reseller.address = data.address
        this.reseller.postalCode = data.postalCode
        this.reseller.city = data.city
        this.reseller.countryCode = data.countryCode
        this.reseller.contactName = data.contactName
        this.reseller.emailAddress = data.emailAddress
        this.reseller.contactPhone = data.contactPhone
        this.reseller.type = data.type
        this.reseller.vendorIds = []
        data.vendorIds.forEach(v => this.reseller.vendorIds.push({ vendorId: v.vendorId, resellerIdentification: v.resellerIdentification }))
      },
      async RefreshCustomers () {
        var customersApiResult = await CustomerService.getForReseller(this.resellerUid)
        if (customersApiResult.success) {
          this.customers = customersApiResult.value
        }
      },
      // event handlers
      CustomerNewHandler () {
      },
      async CustomerRefreshHandler () {
        await this.RefreshCustomers
      },
      CustomerOverviewHandler (customerUid) {
        this.$router.push({ name: 'ResellerCustomerDetails', params: { resellerUid: this.reseller.uid, customerUid: customerUid } })
      },
      CustomerEditHandler (customerUid) {
      },
    },
  }
</script>
